/**
 * BaseConfig
 * responsável
 * manter o environment
 * geral do sistema
 *
 */
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

/**
 * @Injectable()
 * BaseConfig
 * (ciclo angular)
 *
 */
@Injectable()
export class BaseConfig {

  private readonly url: string;
  private readonly host: string;

  /**
   * getBaseUrlApi busca url base
   * @returns string
   */
  public getBaseUrlApi(): string {
    console.log(environment.uri);
    return environment.uri;
  }

  /**
   * constructor()
   * BaseConfig
   * (ciclo angular)
   */
  constructor() {
    environment.uri = this.getBaseUrlApi();
  }

  /**
    * getUrl busca url
    * @returns string
    */
  public getUrl(api: string): string {
      return environment.uri;
  }

}




// WEBPACK FOOTER //
// ./src/app/services/base-config.service.ts